@if (active) {
    <mat-icon class="done green-fg s-20">check</mat-icon>
}
@if (!active) {
    <mat-icon class="clear red-fg s-20">close</mat-icon>
}
